import { Box, Flex, Grid as ChakraGrid } from '@chakra-ui/react';
import { Button, Grid } from '@time-line/components/common';
import { ArrowRight } from '@time-line/components/icons';
import { useInView } from 'react-intersection-observer';

import { Cells } from './Cells';
import { Chart } from './Chart';
import data from './data.json';
import { Multiplier } from './Multiplier';
import { Problem } from './Problem';
import { Solution } from './Solution';

export const MitopureElaborationDesktop = () => {
  const { ref: chartRef, inView: chartInView } = useInView({
    threshold: 1,
    triggerOnce: true,
  });

  const { ref: cellsRef, inView: cellsInView } = useInView({
    threshold: 1,
  });

  return (
    <Box className="mitopure-elaboration--desktop" position="relative">
      <Grid pt="2xl" position="absolute" top={0} left={0} right={0}>
        <Grid.Inner>
          <Box gridColumn="span 6">
            <Problem.Title />
          </Box>
          <Box gridColumn="8/-1">
            <Problem.Description />
          </Box>
        </Grid.Inner>
      </Grid>
      <ChakraGrid
        position="sticky"
        top="10vh"
        textAlign="justify"
        height="62vh"
        minHeight="700px"
        gridAutoFlow="column"
        alignItems="center"
        pointerEvents="none"
        overflowX="hidden"
      >
        <Cells isScrolled={cellsInView} />
      </ChakraGrid>

      <Flex
        flexDir="column"
        bgColor="red.300"
        minH="62vh"
        pt="2xl"
        pb="4xl"
        justifyContent="space-between"
      >
        <Grid pb="4xl" color="white" position="relative" zIndex={2}>
          <Grid.Inner>
            <Box gridColumn="span 6">
              <Solution.Title />
            </Box>
            <Box gridColumn="8/-1">
              <Solution.Description />
              <Button
                as="a"
                href={data.solution.cta.href}
                mt="m"
                variant="outline"
                colorScheme="white"
                isWide
                rightIcon={<ArrowRight />}
              >
                {data.solution.cta.title}
              </Button>
            </Box>
          </Grid.Inner>
        </Grid>
        <Grid position="relative" zIndex={2}>
          <Grid.Inner gridColumnGap="lg" gridRowGap="sm">
            <Multiplier
              gridColumn="span 4"
              width="100%"
              height="auto"
              color="gray.50"
              position="relative"
              top="1.65%"
            />
            <Flex
              gridColumn="span 8"
              color="white"
              position="relative"
              flexDir="column"
              justifyContent="flex-end"
              ref={cellsRef}
            >
              <Chart
                colorScheme="white"
                isScrolled={chartInView}
                intersectionRef={chartRef}
              />
            </Flex>
          </Grid.Inner>
        </Grid>
      </Flex>
    </Box>
  );
};
